'use client'
import { ChevronRightIcon } from '@heroicons/react/20/solid'
import clsx from 'clsx'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'

interface Props {
    step: 1 | 2 | 3
}
export default function BasketHeader({ step }: Props) {
    const { t } = useTranslation()

    return (
        <div className="flex flex-col sm:flex-row gap-4">
            <BasketHeaderStep
                isActive={step === 1}
                heading={t('eshop.basket.header.basket')}
                step={1}
                activeStep={step}
            />
            <BasketHeaderStep
                isActive={step === 2}
                heading={t('eshop.basket.header.invoice')}
                step={2}
                activeStep={step}
            />
            <BasketHeaderStep
                isActive={step === 3}
                heading={t('eshop.basket.header.summary')}
                step={3}
                activeStep={step}
            />
        </div>
    )
}

interface BasketHeaderStepProps extends Props {
    isActive: boolean
    heading: string
    activeStep: number
}

function BasketHeaderStep({
    step,
    isActive,
    heading,
    activeStep,
}: BasketHeaderStepProps) {
    const url = `/eshop/basket${
        step === 1 ? '' : step === 2 ? '/delivery' : 'summary'
    }`
    return (
        <div className="flex items-center gap-4">
            <div
                className={clsx(
                    'rounded-full w-16 h-16 border flex-shrink-0 flex justify-center items-center text-md font-bold ',
                    isActive ? 'bg-primary text-white' : ''
                )}
            >
                {activeStep > step ? <Link href={url}>{step}</Link> : step}
            </div>
            <div className="flex-shrink-0 text-md font-bold">
                {activeStep > step ? (
                    <Link className="hover:underline" href={url}>
                        {heading}
                    </Link>
                ) : (
                    heading
                )}
            </div>
            {(step === 1 || step === 2) && (
                <div className="flex-shrink-0 w-6 h-6">
                    <ChevronRightIcon />
                </div>
            )}
        </div>
    )
}
